/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_BeginnerInputs */

const en_val_beginner = /** @type {(inputs: Val_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beginner`)
};

const es_val_beginner = /** @type {(inputs: Val_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principiante`)
};

const fr_val_beginner = /** @type {(inputs: Val_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Débutant`)
};

const de_val_beginner = /** @type {(inputs: Val_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anfänger`)
};

const ja_val_beginner = /** @type {(inputs: Val_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`初心者向け`)
};

const zh_val_beginner = /** @type {(inputs: Val_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`初级`)
};

const ar_val_beginner = /** @type {(inputs: Val_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مبتدئ`)
};

const id_val_beginner = /** @type {(inputs: Val_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemula`)
};

const it_val_beginner = /** @type {(inputs: Val_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principiante`)
};

const ru_val_beginner = /** @type {(inputs: Val_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новичок`)
};

const pt_val_beginner = /** @type {(inputs: Val_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciante`)
};

const ko_val_beginner = /** @type {(inputs: Val_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`초급`)
};

/**
* | output |
* | --- |
* | "Beginner" |
*
* @param {Val_BeginnerInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_beginner = /** @type {((inputs?: Val_BeginnerInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_BeginnerInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_beginner(inputs)
	if (locale === "es") return es_val_beginner(inputs)
	if (locale === "fr") return fr_val_beginner(inputs)
	if (locale === "de") return de_val_beginner(inputs)
	if (locale === "ja") return ja_val_beginner(inputs)
	if (locale === "zh") return zh_val_beginner(inputs)
	if (locale === "ar") return ar_val_beginner(inputs)
	if (locale === "id") return id_val_beginner(inputs)
	if (locale === "it") return it_val_beginner(inputs)
	if (locale === "ru") return ru_val_beginner(inputs)
	if (locale === "pt") return pt_val_beginner(inputs)
	return ko_val_beginner(inputs)
});